// The video backend's calls that new code makes (building-during-the-rebuild.md, "Backend calls in one small module
// per area"). The Create page's older video calls stay in generate/api.ts.
//
// `token` is the person's Firebase ID token, sent raw in Authorization as the video machines read it.

const VIDEO = process.env.NEXT_PUBLIC_PROMPTCHAN_VIDEO

/**
 * Joins the person's own clips, in order, into one unsaved video (flag extend_clips): `{ video, doc_ref }`, which
 * then saves, publishes and downloads like any other video. Answers 404 outside the flag, 422 `clips_mismatch` for
 * clips of different sizes, 422 `too_long` past the join's limit.
 */
export const joinClips = (token: string, clipIds: string[]) =>
  fetch(`${VIDEO}/api/video_v3.1/clips/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: token },
    body: JSON.stringify({ clip_ids: clipIds }),
  })
